import { Translate } from '~/i18n';

export type StepsType = {
   id: number;
   title: string;
   description: string;
};

export type BankDetailsListType = {
   title: string;
   subtitle?: string;
   value: string;
};

export const Steps = [
   {
      id: 1,
      title: <Translate id="wallet:enter desired amount" />,
      description: <Translate id="wallet:enter customer details and preferences" />,
   },
   {
      id: 2,
      title: <Translate id="wallet:send funds to our bank" />,
      description: <Translate id="wallet:enter customer details and preferences" />,
   },
   {
      id: 3,
      title: <Translate id="wallet:send email to verify" />,
      description: <Translate id="wallet:enter customer details and preferences" />,
   },
];

export const BankDetailsList = [
   {
      title: <Translate id="wallet:bank name" />,
      value: 'Arab National Bank',
   },
   {
      title: <Translate id="wallet:beneficiary name" />,
      value: 'The Ultimate User Experience for IT',
   },
   {
      title: <Translate id="wallet:account number" />,
      value: 'SA9230400108095339050087',
   },
];

export const BranchDetailsList = [
   {
      title: <Translate id="wallet:swift code" />,
      value: 'ARNBSARIXXX',
   },
   {
      title: <Translate id="wallet:branch name" />,
      value: 'ALAQARIAH',
   },
   {
      title: <Translate id="wallet:branch code" />,
      value: '0119',
   },
   {
      title: <Translate id="wallet:branch address" />,
      value: 'Al Aqaria Building, Olaya street, Riyadh, Saudi Arabia',
   },
   {
      title: <Translate id="wallet:currency" />,
      value: 'SAR',
   },
];
